module.exports = __webpack_public_path__ + "img/p6.93bc2517.png";